/**
 * Copyright (c) 2022-present TVM Engineering Authors.
 *
 */
/* eslint-disable */
import axios from "axios";
import { errorHandler, options } from "./index";
import history from "../history/index";
import types from "../actions/types";
import { API_URL } from "../config";
import { actions } from "../reducers/app";
import STATIC_ROUTES from "../route/STATIC_ROUTES";
import { toast_notifications } from "../utils/notifications";
// import getTheUserState from "../utils/userState";

// Authentication services
// TODO Add expiration to cookie

// Use this function for 2FA

// export function fetchSignIn(body) {
//   return async (dispatch) => {
//     try {
//       const response = await axios(options(API_URL + "/auth/signin", body));
//       const responseOK = response && response.status === 200 && response.statusText === "OK";

//       if (responseOK) {
//         // cookie.save("token", response.data.token, STATIC_ROUTES.landingPage);
//         // cookie.save("user", response.data, STATIC_ROUTES.landingPage);
//         dispatch({
//           type: types.SIGN_IN,
//           message: "Welcome. Successfully sign in!",
//           user: response.data,
//         });

//         // history.push(STATIC_ROUTES.dashboard);
//         // history.replace(STATIC_ROUTES.dashboard);
//         // history.go(STATIC_ROUTES.dashboard);
//         return response.data;
//       }
//     } catch (error) {
//       const resErr = error.response;
//       if (error.response.status === 401) {
//         if (error.response.data.userCode === 1) {
//           console.log("Username not found!");
//         }

//         if (error.response.data.passCode === 2) {
//           console.log(
//             "Wrong password! If you forgot password, please click to Forgotten Password Button."
//           );
//           dispatch(
//             actions.showNotification(
//               "Wrong password! If you forgot password, please click to Forgotten Password Button.",
//               true,
//               true,
//               "warning"
//             )
//           );
//         } else {
//           dispatch({
//             type: types.SIGN_IN_ERROR,
//             status: error.response.status,
//             error: error.response.error,
//             message: error.response.message,
//           });
//           dispatch({
//             type: types.UNAUTH_USER,
//             error: {
//               status: resErr.status,
//               error: resErr.error,
//               message: resErr.data.error,
//               statusText: resErr.statusText,
//             },
//           });
//           dispatch(errorHandler(error.response));
//         }
//       } else if (error.response.status === 400) {
//         // Bad request
//         dispatch(errorHandler(error.response));
//       } else {
//         // Something goes really wrong
//         dispatch(errorHandler(error.response));
//       }
//     }
//   };
// }

export function fetchSignIn(body, serverStatus, urlToRedirect) {
  return async (dispatch) => {
    try {
      const response = await axios(options(API_URL + "/auth/signin", body));
      const responseOK = response && response.status === 200 && response.statusText === "OK";

      if (responseOK) {
        if (serverStatus) {
          if (response.data?.user.role?.role_name === "super-admin") {
            // cookie.save("token", response.data.token, STATIC_ROUTES.landingPage);
            // cookie.save("user", response.data, STATIC_ROUTES.landingPage);
            // console.log("what we need to stringify", response.data);
            const user = JSON.parse(response.data);
            sessionStorage.setItem("token", response.data.token);
            sessionStorage.setItem("user", user);
            dispatch({
              type: types.SIGN_IN,
              message: "Welcome. Successfully sign in!",
              user: response.data,
            });

            history.push(STATIC_ROUTES.dashboard);
            history.replace(STATIC_ROUTES.dashboard);
            history.go(STATIC_ROUTES.dashboard);
            return response.data;
          }

          toast_notifications.warning(
            "User login is currently unavailable due to maintenance work."
          );
        } else {
          // cookie.save("token", response.data.token, STATIC_ROUTES.landingPage);
          // cookie.save("user", response.data, STATIC_ROUTES.landingPage);

          const user = JSON.stringify(response.data);
          sessionStorage.setItem("token", response.data.token);
          sessionStorage.setItem("user", user);
          dispatch({
            type: types.SIGN_IN,
            message: "Welcome. Successfully sign in!",
            user: response.data,
          });

          if (urlToRedirect && urlToRedirect.includes("share")) {
            history.push(urlToRedirect);
            history.replace(urlToRedirect);
            history.go(urlToRedirect);
          } else {
            history.push(STATIC_ROUTES.dashboard);
            history.replace(STATIC_ROUTES.dashboard);
            history.go(STATIC_ROUTES.dashboard);
          }

          return response.data;
        }
      }
    } catch (error) {
      const resErr = error.response;
      if (!resErr) {
        // No answer from the server (offline, timeout, blocked request)
        toast_notifications.error(
          "The server cannot be reached. Please check your connection and try again."
        );
      } else if (resErr.status === 401) {
        if (resErr.data?.userCode === 1) {
          console.log("Username not found!");
        }

        if (resErr.data?.passCode === 2) {
          console.log(
            "Wrong password! If you forgot password, please click to Forgotten Password Button."
          );
          toast_notifications.warning(
            "Wrong password! If you forgot password, please click to Forgotten Password Button."
          );
        } else {
          // errorHandler shows the server message (wrong password, locked or not activated account)
          dispatch({
            type: types.SIGN_IN_ERROR,
            status: error.response.status,
            error: error.response.error,
            message: error.response.message,
          });
          dispatch({
            type: types.UNAUTH_USER,
            error: {
              status: resErr.status,
              error: resErr.error,
              message: resErr.data.error,
              statusText: resErr.statusText,
            },
          });
          dispatch(errorHandler(error.response));
        }
      } else if (resErr.status === 502) {
        toast_notifications.warning("User login is currently unavailable due to maintenance work.");
      } else {
        // Bad request or server error: errorHandler shows no toast for these statuses
        const serverMessage = typeof resErr.data?.error === "string" ? resErr.data.error : null;
        toast_notifications.error(serverMessage || "Login failed. Please try again later.");
        dispatch(errorHandler(error.response));
      }
    }
  };
}
/*

export function fetchDevSignIn() {
  return async (dispatch) => {
    try {
      // const response = await axios(options(API_URL + '/auth/signin', body));
      // const responseOK = response && response.status === 200 && response.statusText === 'OK';
      const userRole = hardCodedData.user.role;
      const path = userRole === ROLES.SUPER_ADMIN ? STATIC_ROUTES.projects : STATIC_ROUTES.projects;

      /!*   if (responseOK) {
        cookie.save('token', response.data.token, STATIC_ROUTES.landingPage);
        cookie.save('user', response.data, STATIC_ROUTES.landingPage);
        dispatch({
          type: types.SIGN_IN,
          message: 'Welcome. Successfully sign in!',
          user: response.data,
        });
        if (userRole === ROLES.SUPER_ADMIN) {
          cookie.save('token', response.data.token, STATIC_ROUTES.projects);
          cookie.save('user', response.data, STATIC_ROUTES.projects);
          history.push(path);
          history.replace(path);
          history.go(path);
          dispatch(actions.showNotification('Welcome. Successfully sign in!', true));
        } else {
          cookie.save('token', response.data.token, { path });
          cookie.save('user', response.data, { path });
          history.push(path);
          history.replace(path);
          history.go(path);
          dispatch(actions.showNotification('Welcome. Successfully sign in!', true));
        }
      }
      *!/
      cookie.save('token', hardCodedData.token, STATIC_ROUTES.projects);
      cookie.save('user', hardCodedData, STATIC_ROUTES.projects);
      history.push(path);
      history.replace(path);
      history.go(path);
    } catch (error) {
      const resErr = error.response;
      if (error.response.status === 401) {
        if (error.response.data.userCode === 1) {
          console.log('Username not found!');
        }
        if (error.response.data.passCode === 2) {
          console.log('Wrong password! If you forgot password, please click to Forgotten Password Button');
        } else {
          dispatch({
            type: types.SIGN_IN_ERROR,
            status: error.response.status,
            error: error.response.error,
            message: error.response.message
          });
          dispatch({
            type: types.UNAUTH_USER,
            error: {
              status: resErr.status,
              error: resErr.error,
              message: resErr.data.error,
              statusText: resErr.statusText
            }
          });
          dispatch(errorHandler(error.response));
        }
      } else if (error.response.status === 400) {
        // Bad request
        dispatch(errorHandler(error.response));
      } else {
        // Something goes really wrong
        dispatch(errorHandler(error.response));
      }
    }
  };
}
*/

export function fetchSignUp(body, type) {
  const appendQuery = "?registered=true";
  return async (dispatch) => {
    try {
      const response = await axios(options(API_URL + "/auth/signup", body));
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        // const data = await response.data;
        // cookie.save('sessionID', data.user.sessionID, { path: '/projects' });
        // cookie.save('user', data.data.user, { path: STATIC_ROUTES.projects });
        // dispatch({ type: types.AUTH_USER });
        if (type === "create_admin") {
          toast_notifications.success(
            "User Successfully created! Email for confirmation was send!"
          );
        } else {
          history.push(STATIC_ROUTES.registrationForward + appendQuery);
          history.replace(STATIC_ROUTES.registrationForward + appendQuery);
          // history.go(STATIC_ROUTES.registrationForward + appendQuery);
          toast_notifications.success("Successfully sign up!");
          return response?.data;
        }
      }
    } catch (error) {
      toast_notifications.warning(error?.response?.data?.error || "Something went wrong!");
      console.warn("Error:", error);
      // dispatch(errorHandler(error));
    }
  };
}

export function logoutUser(error) {
  return async (dispatch) => {
    try {
      const response = await axios(options(API_URL + `/auth/log-out`, {}, "get"));

      history.push(STATIC_ROUTES.landingPage);
      history.replace(STATIC_ROUTES.landingPage);
      // history.go(STATIC_ROUTES.landingPage);

      if (response.data?.message) {
        toast_notifications.info(response.data.message);
      }

      dispatch({ type: types.UNAUTH_USER, payload: error || "" });
      // cookie.remove("token", { path: STATIC_ROUTES.landingPage });
      // cookie.remove("user", { path: STATIC_ROUTES.landingPage });

      // const user = JSON.stringify(response.data);
      sessionStorage.clear();
      // sessionStorage.setItem("token", response.data.token);
      // sessionStorage.setItem("user", user);
    } catch (err) {
      console.warn("Error:", err);
      dispatch(errorHandler(err));
    }
  };
}

export function fetchGetForgotPasswordToken(body) {
  return async (dispatch) => {
    try {
      const response = await axios(options(API_URL + "/auth/password", body));
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        const data = await response.data;
        dispatch({
          type: types.FORGOT_PASSWORD_REQUEST,
          payload: data.data, // json.user,
        });
      }
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

export function fetchResetPassword(token, data) {
  return async (dispatch) => {
    try {
      const response = await axios(options(API_URL + "/auth/reset-password/" + token, data));
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        const res = await response.data;
        dispatch({
          type: types.RESET_PASSWORD_REQUEST,
          payload: res.data, // json.user,
        });
      }
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

export function confirmRegistration() {
  return async (dispatch) => {
    try {
      const response = await axios(options(API_URL + window.location.pathname, {}, "get"));
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        return response.data;
      }
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

export function removeUserByCode() {
  return async (dispatch) => {
    try {
      const response = await axios(options(API_URL + window.location.pathname, {}, "get"));
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        return response.data;
      }
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

export function checkEmailExists(body) {
  return async (dispatch) => {
    try {
      const response = await axios(options(API_URL + "/auth/checkEmailExists", body));
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        return response.data;
      }
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

export function checkEmailOnPasswordReset(body) {
  return async (dispatch) => {
    try {
      const response = await axios(options(API_URL + "/auth/checkEmailOnPasswordReset", body));
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        return response.data;
      }
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

export function resetPassword(body) {
  return async (dispatch) => {
    try {
      const response = await axios(options(API_URL + "/reset-password", body));
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        localStorage.clear();
        sessionStorage.clear();
        // cookie.remove("user");
        // cookie.remove("token");
        // history.push(STATIC_ROUTES.landingPage);

        toast_notifications.success(response.data);
      }
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

export function checkPasswordExpiryService(code) {
  return async (dispatch) => {
    try {
      const response = await axios(options(API_URL + `/reset-password/${code}`, {}, "get"));
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        return response.data;
      }
    } catch (error) {
      if (error.response.status === 404) {
        return error.response.data;
      }
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

export function verifyQrCode(data, urlToRedirect) {
  return async (dispatch) => {
    try {
      const response = await axios(options(API_URL + `/auth/verification`, data, "post"));
      // const responseOK = response && response.status === 200 && response.statusText === "OK";

      if (response.data?.message) {
        toast_notifications.error(response.data.message);
      } else {
        const user = JSON.stringify(response.data);

        sessionStorage.setItem("token", response.data.token);
        sessionStorage.setItem("user", user);
        dispatch({
          type: types.SIGN_IN,
          message: "Welcome. Successfully sign in!",
          user: response.data,
        });
        if (urlToRedirect && urlToRedirect.includes("share")) {
          console.log("URL TO REDIRECT", urlToRedirect);
          history.push(urlToRedirect);
          history.replace(urlToRedirect);
          history.go(urlToRedirect);
        } else {
          history.push(STATIC_ROUTES.dashboard);
          history.replace(STATIC_ROUTES.dashboard);
          history.go(STATIC_ROUTES.dashboard);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
}

export function sendVerifyCodeToEmail(data, type) {
  return async (dispatch) => {
    const response = await axios(options(API_URL + `/user/sendVerifyCodeToEmail`, data, "post"));
    const responseOK = response && response.status === 200 && response.statusText === "OK";

    if (type === "resend" && responseOK) {
      toast_notifications.info("Verification code was resend to your email!");
    }

    if (response.data?.message) {
      toast_notifications.error(response.data.message);
    }
  };
}

export function verifyByEmailCode(data, urlToRedirect) {
  return async (dispatch) => {
    const response = await axios(options(API_URL + `/user/verifyByEmailCode`, data, "post"));

    if (!response.data?.valid) {
      toast_notifications.error(response.data.message);
    } else {
      const user = JSON.stringify(response.data);

      sessionStorage.setItem("token", response.data.token);
      sessionStorage.setItem("user", user);
      dispatch({
        type: types.SIGN_IN,
        message: "Welcome. Successfully sign in!",
        user: response.data,
      });
      if (urlToRedirect && urlToRedirect.includes("share")) {
        history.push(urlToRedirect);
        history.replace(urlToRedirect);
        history.go(urlToRedirect);
      } else {
        history.push(STATIC_ROUTES.dashboard);
        history.replace(STATIC_ROUTES.dashboard);
        history.go(STATIC_ROUTES.dashboard);
      }
    }
  };
}

export function sendQrCodeToEmail(data) {
  return async (dispatch) => {
    try {
      const response = await axios(options(API_URL + `/user/sendQrCode`, data, "post"));

      if (response.data?.message) {
        toast_notifications.info(response.data.message);
      }
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}
